export default __webpack_public_path__ + "static/armony-plus-4-2462700320fb56bf638efe5b291f41c3.jpg";